/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var TimePeriodEnum;

(function (TimePeriodEnum) {
  TimePeriodEnum["DAY"] = "day";
  TimePeriodEnum["MONTH"] = "month";
  TimePeriodEnum["YEAR"] = "year";
  TimePeriodEnum["ALL_TIME"] = "all_time";
})(TimePeriodEnum || (TimePeriodEnum = {}));